import { Controller } from '@hotwired/stimulus'

const SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style="width:18px;height:18px;display:block"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.489 5.8a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z" /></svg>'

export default class extends Controller {
  connect () {
    this.comboboxes = Array.from(this.element.querySelectorAll('.hw-combobox'))
    this.buttons = this.comboboxes.map((cb) => this.attachClearButton(cb))

    this.handler = () => this.updateAll()
    this.element.addEventListener('input', this.handler)
    this.element.addEventListener('change', this.handler)
    this.element.addEventListener('hw-combobox:selection', this.handler)

    requestAnimationFrame(() => this.updateAll())
  }

  disconnect () {
    this.buttons.forEach((b) => b?.remove())
    this.element.removeEventListener('input', this.handler)
    this.element.removeEventListener('change', this.handler)
    this.element.removeEventListener('hw-combobox:selection', this.handler)
  }

  attachClearButton (combobox) {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.setAttribute('aria-label', 'Clear')
    btn.innerHTML = SVG
    Object.assign(btn.style, {
      position: 'absolute',
      right: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '20px',
      height: '20px',
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#9CA3AF',
      cursor: 'pointer',
      background: 'transparent',
      border: 'none',
      padding: '0',
      zIndex: '10'
    })

    btn.addEventListener('mouseenter', () => { btn.style.color = '#374151' })
    btn.addEventListener('mouseleave', () => { btn.style.color = '#9CA3AF' })
    btn.addEventListener('click', (e) => this.clear(e, combobox))

    combobox.appendChild(btn)
    return btn
  }

  clear (event, combobox) {
    event.preventDefault()
    event.stopPropagation()
    const visibleInput = combobox.querySelector('.hw-combobox__input')
    const hiddenInput = combobox.querySelector('input[type="hidden"]')

    if (visibleInput) {
      visibleInput.value = ''
      visibleInput.dispatchEvent(new Event('input', { bubbles: true }))
    }
    if (hiddenInput) {
      hiddenInput.value = ''
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }))
    }

    visibleInput?.focus()
    this.updateAll()
  }

  updateAll () {
    this.comboboxes.forEach((cb, i) => {
      const hidden = cb.querySelector('input[type="hidden"]')
      const btn = this.buttons[i]
      if (!btn) return
      const hasValue = hidden && hidden.value && hidden.value.length > 0
      btn.style.display = hasValue ? 'flex' : 'none'
    })
  }
}
